import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blog-posts.js';
import SEO from '../components/SEO.jsx';
import useReveal from '../hooks/useReveal.js';
import { organizationSchema, buildItemListSchema } from '../data/schemas.js';

function fmtDate(iso) {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getFullYear()).slice(2)}`;
}

export default function BlogIndex() {
  useReveal();
  const [featured, ...rest] = BLOG_POSTS;
  return (
    <main className="blog-page">
      <SEO
        title="בלוג"
        description="חושב בקול. לא תחת לחץ של מה שטרנדי. כותב מתי שיש משהו אמיתי לכתוב."
        path="/blog"
        schema={[
          organizationSchema,
          buildItemListSchema(
            BLOG_POSTS.map(p => ({ name: p.title, url: `/blog/${p.slug}` })),
            'בלוג FocusMode'
          )
        ].filter(Boolean)}
      />

      <section className="blog-head">
        <div className="wrap">
          <div className="blog-head-crumb">
            <Link to="/">דף הבית</Link>
            <span className="sep">›</span>
            בלוג
          </div>
          <div className="blog-head-row">
            <div className="blog-head-text">
              <div className="blog-head-eyebrow">בלוג FocusMode</div>
              <h1 className="blog-head-title">חושב בקול. <span className="blog-head-accent">מהשטח.</span></h1>
              <p className="blog-head-lede">פוסטים שאני כותב כשיש לי משהו אמיתי לכתוב. על מערכות, ארגונים, AI ותהליכים — מהפרויקטים של היומיום.</p>
            </div>
            <div className="blog-head-filters">
              <button className="blog-filter is-active">הכל</button>
              <button className="blog-filter">פיתוח עם AI</button>
              <button className="blog-filter">אוטומציות</button>
              <button className="blog-filter">מערכות</button>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-featured-section">
        <div className="wrap">
          <Link className="blog-featured reveal" to={`/blog/${featured.slug}`}>
            <div className="blog-featured-media">
              <image-slot
                id={`blog-cover-${featured.slug}`}
                shape="rounded"
                radius="20"
                placeholder={featured.heroPlaceholder || 'גררו תמונת נושא'}
                style={{ width:'100%', height:'100%' }}
              ></image-slot>
              <span className="blog-featured-badge">המומלץ</span>
            </div>
            <div className="blog-featured-body">
              <div className="blog-card-eyebrow">{featured.eyebrow}</div>
              <h2 className="blog-featured-title">{featured.title}</h2>
              <p className="blog-featured-excerpt">{featured.excerpt}</p>
              <div className="blog-card-meta">
                <span className="blog-card-author">
                  <span className="blog-card-author-dot" aria-hidden="true">YR</span>
                  יואב רון
                </span>
                <span className="dot">·</span>
                <span>{fmtDate(featured.date)}</span>
                <span className="dot">·</span>
                <span>{featured.readingTime}</span>
              </div>
              <div className="blog-featured-cta">המשך קריאה ←</div>
            </div>
          </Link>
        </div>
      </section>

      <section className="blog-grid-section">
        <div className="wrap">
          <div className="blog-grid-row">
            <div className="blog-grid-eyebrow">כל הפוסטים</div>
            <div className="blog-grid-sort">מיון: <strong>החדשים ביותר</strong></div>
          </div>
          <div className="blog-grid">
            {rest.map(p => (
              <Link key={p.slug} className="blog-card reveal" to={`/blog/${p.slug}`}>
                <div className="blog-card-media">
                  <image-slot
                    id={`blog-cover-${p.slug}`}
                    shape="rounded"
                    radius="14"
                    placeholder={p.heroPlaceholder || 'תמונת נושא'}
                    style={{ width:'100%', height:'100%' }}
                  ></image-slot>
                </div>
                <div className="blog-card-body">
                  <div className="blog-card-eyebrow">{p.eyebrow}</div>
                  <h3 className="blog-card-title">{p.title}</h3>
                  <p className="blog-card-excerpt">{p.excerpt}</p>
                  <div className="blog-card-meta">
                    <span>{fmtDate(p.date)}</span>
                    <span className="dot">·</span>
                    <span>{p.readingTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="blog-newsletter-band">
        <div className="wrap">
          <div className="bnb-inner">
            <div>
              <div className="bnb-eyebrow">FocusMode · עדכונים</div>
              <h3 className="bnb-title">פוסט חדש פעם בשבועיים, בדיוק כשיש משהו אמיתי לכתוב.</h3>
            </div>
            <form className="bnb-form" onSubmit={e => e.preventDefault()}>
              <input type="email" required placeholder="כתובת מייל" />
              <button type="submit">הרשמה</button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}
